import type { UnitsSettings } from "./units";
import { defaultUnitsSettings } from "./units";

const DEFAULT_KEY = "m1member.units.default";
const userKey = (accountId: string) => `m1member.units.user.${accountId}`;
const userStudioKey = (accountId: string, studioId: string) => `m1member.units.user.${accountId}.studio.${studioId}`;

function safeParse(raw: string | null): UnitsSettings | null {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as UnitsSettings;
  } catch {
    return null;
  }
}

/**
 * Lädt Einheiten-Einstellungen. Optional pro Studio (studioId); dann zuerst Studio-Key, sonst Fallback auf Account-Default.
 */
export function loadUnits(accountId?: string | null, studioId?: string | null): UnitsSettings {
  if (accountId && studioId) {
    const u = safeParse(localStorage.getItem(userStudioKey(accountId, studioId)));
    if (u) return { ...defaultUnitsSettings, ...u };
  }
  if (accountId) {
    const u = safeParse(localStorage.getItem(userKey(accountId)));
    if (u) return { ...defaultUnitsSettings, ...u };
  }
  const d = safeParse(localStorage.getItem(DEFAULT_KEY));
  return { ...defaultUnitsSettings, ...(d ?? {}) };
}

/**
 * Speichert Einheiten-Einstellungen. Optional pro Studio (studioId).
 */
export function saveUnits(units: UnitsSettings, accountId?: string | null, studioId?: string | null) {
  const raw = JSON.stringify(units);
  if (accountId && studioId) {
    localStorage.setItem(userStudioKey(accountId, studioId), raw);
    return;
  }
  if (accountId) {
    localStorage.setItem(userKey(accountId), raw);
    return;
  }
  localStorage.setItem(DEFAULT_KEY, raw);
}




















